<script>
  // import { onMount } from "svelte";
  // import { createEventDispatcher } from "svelte";
  import ColorMixer from "./ColorMixer.svelte";

  import chroma from "chroma-js";

  export let codeText;

  let codeTextObject,
    updatedCodeText = codeText;

  // const dispatch = createEventDispatcher();

  let modal;

  let gradientTypeInput,
    shapeInput,
    angelInput,
    originXInput,
    originYInput,
    Dir1Input,
    Dir2Input,
    repeatingInput,
    arrColorInput,
    arrColorsStopsInput;

  let {
    gradientType,
    linearGradientInfo,
    radialGradientInfo,
    direction1,
    direction2,
    angle,
    originX,
    originY,
    colorStopsCount,
    colorStops,
    colorRGBAData,
    colorHEXData,

    isRepeated,
  } = parseText(codeText);

  const changeColor = (e) => {
    // console.log("stops", colorStops, "key===", e.detail.key);
    if (e !== undefined) {
      colorStops[e.detail.key].color = e.detail.hexColor;
      updateTheGradientView();
    }
  };

  const changeColorStops = (e) => {
    // console.log("stops", colorStops, "key===", e.detail.key);
    if (e !== undefined) {
      colorStops[e.detail.key].stop = `${e.detail.colorStop}%`;
      updateTheGradientView();
    }
  };

  const updateTheGradientView = () => {
    let gradientParam;
    gradientType = gradientTypeInput.value;
    const repeating = repeatingInput.checked ? "repeating-" : "";
    const buildColorsStops = () => {
      let arrCs = [];
      colorStops.forEach((item) => {
        arrCs.push(item.color + " " + item.stop);
      });
      return arrCs.join(",");
    };

    if (gradientType === "linear-gradient") {
      if (linearGradientInfo.length === 1) {
        angle = angelInput.value;
        gradientParam = angle.toString() + "deg";
      } else if (linearGradientInfo[0] === "to") {
        direction1 = Dir1Input.value;
        gradientParam = `to ${direction1}`;
        if (linearGradientInfo[2] !== undefined) {
          direction2 = Dir2Input.value;
          gradientParam = `to ${direction1} ${direction2}`;
        }
        //if two direction is the same
        if (direction1 === direction2) gradientParam = `to ${direction1}`;
      }
    } else {
      const shape = shapeInput.value;
      if (radialGradientInfo.join("-").indexOf("%") === -1) {
        // console.log("DD", radialGradientInfo[2], radialGradientInfo.join("-"));
        //no persentage position
        direction1 = Dir1Input.value;
        direction2 = Dir2Input.value;
        gradientParam = `${shape} at ${direction1} ${direction2}`;
        // if (linearGradientInfo[2] !== undefined) {
        //   gradientParam = `to ${direction1} ${direction2}`;
      } else {
        originX = originXInput.value;
        originY = originYInput.value;
        gradientParam = `${shape} at ${originX}% ${originY}%`;
      }
      // console.log(gradientParam);
    }

    // const gradientParam =
    //   gradientType === "linear-gradient"
    //     ? linearGradientInfo.join(" ")
    //     : radialGradientInfo.join(" ");
    console.log(buildColorsStops());
    //colorStops.join(",");
    updatedCodeText = `background:${repeating}${gradientType}(${gradientParam},${buildColorsStops()});`;
  };

  const openModal = () => {
    modal.style.display = "block";
  };
  // When the user clicks on <span> (x), close the modal
  const spanonclick = () => {
    modal.style.display = "none";
  };

  // When the user clicks anywhere outside of the modal, close it
  const onModalClick = (event) => {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  ///////////////////////////////////////////////////

  function parseText(codeText) {
    // var this = this;

    /***
        this function return an object of 
        {
          gradientType: gradientType,
          linearGradientInfo : linearGradientInfo ,
          radialGradientInfo: radialGradientInfo,
          direction: direction,
          angle: angle,
          colorStopsCount: arrColorStops.length - 1,
          colorStops: arrParsedRGBColors,
          isRepeated: gradientType.slice(0, 9) === "repeating",
        }
        */

    //convert the whole code text from hex color system to rgb or rgba color system
    const convertRGBLeteralToHEX = (codeText) => {
      let splitted, isRGBA;
      let arrRGB = [];
      if (codeText.indexOf("rgba") === -1) {
        splitted = codeText.split("rgb");
        isRGBA = false;
      } else {
        splitted = codeText.split("rgba");
        isRGBA = true;
      }
      // console.log(splitted);
      //ignore first   elemet
      let i,
        arrHEX = [];
      for (i = 1; i < splitted.length; i++) {
        let strTemp,
          ele,
          arrTemp = [];
        ele = splitted[i];
        strTemp = ele.slice(ele.indexOf("(") + 1, ele.indexOf(")"));
        arrTemp = strTemp.split(",");
        arrRGB.push(arrTemp);
        // console.log("INSIDE", arrRGB);
      }
      //covert from rgb/a to hex colors
      for (i = 0; i < arrRGB.length; i++) {
        if (isRGBA) {
          arrHEX.push(
            chroma(
              `rgba(${arrRGB[i][0]},${arrRGB[i][1]},${arrRGB[i][2]},${arrRGB[i][3]})`
            ).hex()
          );
        } else {
          arrHEX.push(chroma([arrRGB[i][0], arrRGB[i][1], arrRGB[i][2]]).hex());
        }
      }

      //   now replace each rgb/a() to it HEX counterpart
      let counter = 0; //tracker
      let rgbaPos = isRGBA ? codeText.indexOf("rgba") : codeText.indexOf("rgb");
      let rightParenth = codeText.indexOf(")");
      let sliced,
        arrSlicedRGBAs = [];
      // get the rgba occurences in the text
      while (rgbaPos > 0) {
        sliced = codeText.slice(rgbaPos, rightParenth + 1);
        arrSlicedRGBAs.push(sliced);
        rgbaPos = isRGBA
          ? codeText.indexOf("rgba", rightParenth + 1)
          : codeText.indexOf("rgb", rightParenth + 1);
        rightParenth = codeText.indexOf(")", rightParenth + 1);
      }
      for (i = 0; i < arrSlicedRGBAs.length; i++) {
        codeText = codeText.replace(arrSlicedRGBAs[i], arrHEX[i]);
      }

      return [codeText, arrRGB, arrHEX];
    };

    // console.log("RGB2HEX", convertRGBLeteralToHEX(codeText));

    //extract the actual angle
    const getAngle = (ang) => {
      let degIndex = ang.indexOf("deg");
      return ang.slice(0, degIndex);
    };

    const parseRGBColorStops = (arrRatterns) => {
      //this func anlyze array of stops and return array
      //objects [{color: c, stop: xxx%} , ..]
      //pattern := #abcdef xxx%
      let arrTemp = [];
      //   ignore the first (does't contains any color info) and last elements
      let i;
      //ignore the first element
      for (i = 1; i < arrRatterns.length - 1; i++) {
        let element = arrRatterns[i].trim();
        let spacePos = element.indexOf(" ");
        let colorCode = "#" + element.slice(0, spacePos);
        let stop = element.slice(spacePos + 1, element.indexOf("%") + 1).trim();
        arrTemp.push({ color: colorCode, stop: stop });
      }
      //anlyze last arrPatterns element  NOTE its of e280c3 100%);
      let element = arrRatterns[i].trim();
      let spacePos = element.indexOf(" ");
      let colorCode = "#" + element.slice(0, spacePos).trim();
      let stop = element.slice(spacePos + 1, element.indexOf("%") + 1).trim();
      arrTemp.push({ color: colorCode, stop: stop });

      return arrTemp;
    };

    const colonPos = codeText.indexOf(":");
    const leftParethPos = codeText.indexOf("(");
    const gradientType = codeText.slice(colonPos + 1, leftParethPos).trim();
    let arrRGB, arrHEX;

    // console.log("gradient =", gradientType);

    //get the direction or angle for pattern ((to direction and xxdeg))
    // for linear-gradient
    const firstComma = codeText.indexOf(",");
    const directionOrAngle = codeText
      .slice(leftParethPos + 1, firstComma)
      .trim();
    let direction, angle;

    // console.log("direction or angle = ", directionOrAngle);
    // console.log("direction   = ", direction);
    // console.log("angle   = ", angle);

    //if gradient type is radial then look for shape , directions or persentage
    let radialGradientInfo, linearGradientInfo;
    if (gradientType.indexOf("radial") > -1) {
      radialGradientInfo = directionOrAngle.split(" ");
      angle = null;
      direction = null;
    } else {
      linearGradientInfo = directionOrAngle.split(" ");
      if (directionOrAngle.indexOf("deg") > -1)
        // direction = directionOrAngle.slice(3).trim();
        angle = getAngle(directionOrAngle).trim();
    }

    // convert the color system from rgb/a to hex system
    [codeText, arrRGB, arrHEX] = convertRGBLeteralToHEX(codeText);
    // console.log("HERE", arrRGB, arrHEX);
    //get the color and its stop
    const arrColorStops = codeText.split("#");
    // console.log(arrColorStops);

    // console.log(parseRGBColorStops(arrColorStops));
    const arrParsedRGBColors = parseRGBColorStops(arrColorStops);
    //grab the hex code from arrParsedRGBColors and store it in arrHEX
    arrParsedRGBColors.forEach((item) => {
      arrHEX.push(item.color);
    });
    // console.log("Lin", linearGradientInfo);
    console.log(arrParsedRGBColors);
    return {
      gradientType: gradientType,
      linearGradientInfo: linearGradientInfo,
      radialGradientInfo: radialGradientInfo,
      direction: direction,
      angle: angle,
      colorStopsCount: arrColorStops.length - 1,
      colorStops: arrParsedRGBColors,
      colorRGBAData: arrRGB,
      colorHEXData: arrHEX,
      isRepeated: gradientType.slice(0, 9) === "repeating",
    };
  }

  ///////
  function infalteUI(uiObj) {}
</script>

<div id="myModal" bind:this={modal} on:click={onModalClick} class="modal">
  <!-- Modal content -->

  <div class="modal-content">
    <span class="close" on:click={spanonclick}>&times;</span>
    <div class="info-area">
      <div class="gradient-container">
        <div class="bg-gradient" style={updatedCodeText} />
        <p class="text-of-gradient-style">{updatedCodeText}</p>
        <button
          class="edit-button"
          on:click={() => {
            const cb = navigator.clipboard;
            const paragraph = document.querySelector("p");
            cb.writeText(updatedCodeText).then(() => alert("Style copied"));
          }}>Copy Style</button
        >
      </div>
      <div>
        Gradient Type :
        <!-- Current {gradientType}<br />
        Change : -->
        <select
          on:change={updateTheGradientView}
          bind:this={gradientTypeInput}
          disabled="disabled"
        >
          <option
            selected={gradientType.indexOf("linear") > -1}
            value="linear-gradient"
            >Linear Gradient
          </option>
          <option
            selected={gradientType.indexOf("radial") > -1}
            value="radial-gradient">Radial gradient</option
          >
        </select>
      </div>
      {#if gradientType.indexOf("linear") > -1}
        <div>
          <!-- // linearGradientInfo : {linearGradientInfo} -->

          {#if angle !== undefined}
            <div>
              angle :
              <input
                type="range"
                on:change={updateTheGradientView}
                on:input={updateTheGradientView}
                bind:this={angelInput}
                min="-360"
                max="360"
                value={angle}
              />
              {angle}
            </div>
          {:else}
            Origin:
            {#if linearGradientInfo[0].indexOf("deg") === -1}
              <div>
                <select on:change={updateTheGradientView} bind:this={Dir1Input}>
                  <!-- <option
                    value="center"
                    selected={linearGradientInfo[1].trim() === "center"}
                    >Center</option
                  > -->
                  <option
                    value="top"
                    selected={linearGradientInfo[1].trim() === "top"}
                    >Top</option
                  >
                  <option
                    value="left"
                    selected={linearGradientInfo[1].trim() === "left"}
                    >Left</option
                  >
                  <option
                    value="bottom"
                    selected={linearGradientInfo[1].trim() === "bottom"}
                    >Bottom</option
                  >
                  <option
                    value="right"
                    selected={linearGradientInfo[1].trim() === "right"}
                    >Right</option
                  >
                </select>
                {#if linearGradientInfo[2] !== undefined}
                  <select
                    on:change={updateTheGradientView}
                    bind:this={Dir2Input}
                  >
                    <!-- <option
                      value="center"
                      selected={linearGradientInfo[2].trim() === "center"}
                      >Center</option
                    > -->
                    <option
                      value="top"
                      selected={linearGradientInfo[2].trim() === "top"}
                      >Top</option
                    >
                    <option
                      value="left"
                      selected={linearGradientInfo[2].trim() === "left"}
                      >Left</option
                    >
                    <option
                      value="bottom"
                      selected={linearGradientInfo[2].trim() === "bottom"}
                      >Bottom</option
                    >
                    <option
                      value="right"
                      selected={linearGradientInfo[2].trim() === "right"}
                      >Right</option
                    >
                  </select>
                {/if}
              </div>
            {:else}
              <div>
                <input
                  bind:this={originXInput}
                  type="number"
                  min="0"
                  max="100"
                  value={parseInt(linearGradientInfo[1].replace("%", ""))}
                  on:change={updateTheGradientView}
                  on:input={updateTheGradientView}
                />
                %
                <input
                  bind:this={originYInput}
                  type="number"
                  min="0"
                  max="100"
                  value={parseInt(linearGradientInfo[2].replace("%", ""))}
                  on:change={updateTheGradientView}
                  on:input={updateTheGradientView}
                /> %
              </div>
            {/if}
          {/if}
        </div>
      {/if}

      {#if gradientType.indexOf("radial") > -1}
        <!-- radialGradientInfo : {radialGradientInfo} -->
        <div>
          shape :
          <select on:change={updateTheGradientView} bind:this={shapeInput}>
            <option
              value="circle"
              selected={radialGradientInfo[0].trim() === "circle"}
              >Circle</option
            >
            <option
              value="ellipse"
              selected={radialGradientInfo[0].trim() === "ellipse"}
              >Ellipse</option
            >
          </select>
        </div>
        Origin:
        {#if radialGradientInfo[3].indexOf("%") === -1}
          <div>
            <select on:change={updateTheGradientView} bind:this={Dir1Input}>
              <option
                value="center"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 2
                ].trim() === "center"}>Center</option
              >
              <option
                value="top"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 2
                ].trim() === "top"}>Top</option
              >
              <option
                value="left"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 2
                ].trim() === "left"}>Left</option
              >
              <option
                value="bottom"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 2
                ].trim() === "bottom"}>Bottom</option
              >
              <option
                value="right"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 2
                ].trim() === "right"}>Right</option
              >
            </select>
            <select on:change={updateTheGradientView} bind:this={Dir2Input}>
              <option
                value="center"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 1
                ].trim() === "center"}>Center</option
              >
              <option
                value="top"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 1
                ].trim() === "top"}>Top</option
              >
              <option
                value="left"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 1
                ].trim() === "left"}>Left</option
              >
              <option
                value="bottom"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 1
                ].trim() === "bottom"}>Bottom</option
              >
              <option
                value="right"
                selected={radialGradientInfo[
                  radialGradientInfo.length - 1
                ].trim() === "right"}>Right</option
              >
            </select>
          </div>
        {:else}
          <div>
            <input
              bind:this={originXInput}
              type="number"
              min="0"
              max="100"
              value={parseInt(
                radialGradientInfo[radialGradientInfo.length - 2].replace(
                  "%",
                  ""
                )
              )}
              on:change={updateTheGradientView}
              on:input={updateTheGradientView}
            />
            %
            <input
              bind:this={originYInput}
              type="number"
              min="0"
              max="100"
              value={parseInt(
                radialGradientInfo[radialGradientInfo.length - 1].replace(
                  "%",
                  ""
                )
              )}
              on:change={updateTheGradientView}
              on:input={updateTheGradientView}
            /> %
          </div>
        {/if}
      {/if}

      <div>
        Color Stops :
        <ul>
          {#each colorStops as cs, index}
            <li>
              <ColorMixer
                key={index}
                hexColor={colorHEXData[index]}
                colorStopVal={cs.stop.slice(0, cs.stop.indexOf("%"))}
                on:colorChanged={changeColor}
                on:colorStopChanged={changeColorStops}
                hasColorStop
              />
            </li>
          {/each}
        </ul>

        <!-- {colorStops} -->
      </div>

      Repeated? :<input
        type="checkbox"
        on:change={updateTheGradientView}
        bind:this={repeatingInput}
        checked={isRepeated}
      />
    </div>
  </div>
</div>

<button class="edit-button" on:click={openModal}>Edit</button>

<style>
  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 8% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 90%; /* Could be more or less, depending on screen size */
  }
  .gradient-container {
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 220px;
    border: 1px solid gray;
    margin: 12px auto;
  }
  .text-of-gradient-style {
    font-size: 12px;
    border-top: 3px ridge rgb(165, 161, 161);
    padding: 6;
    margin: 0;
  }
  .bg-gradient {
    width: 100%;
    height: 100%;
    /* margin: 12px 6px; */
  }
  ul {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  input[type="number"] {
    width: 50px;
    font-weight: bold;
  }
</style>
